export const VoucherType = {
  percentage: 'percentage',
  valueInPence: 'value_in_pence',
  giftCard: 'gift_card',
} as const

export const VoucherDiscount = VoucherType

export type VoucherDiscountType = (typeof VoucherType)[keyof typeof VoucherType]

export const VoucherMechanism = {
  membership: 'membership',
  memberGetMember: 'member_get_member',
} as const

export type VoucherMechanismType =
  (typeof VoucherMechanism)[keyof typeof VoucherMechanism]

export type VoucherOfferAttributes = {
  partnerName?: string
  offer?: string
  [key: string]: unknown
}

export type VoucherAttributes = {
  id: string
  code: string
  productName: string
  discountType: VoucherDiscountType
  discountValue: number
  brandId: string | null
  expiresAt: string | null
  mechanism: VoucherMechanismType | null
  offerAttributes: VoucherOfferAttributes
  usageLimit: number | null
  referrals: number
  usage: number
  createdAt: string
  updatedAt: string
}

export type Voucher = {
  type: 'vouchers'
  attributes: VoucherAttributes
}

/**
 * Mirrors server `Voucher.processDiscount` for client-side price previews.
 * Gift cards do not reduce the payable amount.
 */
export const processDiscount = ({
  priceInPence,
  discountType,
  discountValue,
}: {
  priceInPence: number
  discountType: VoucherDiscountType
  discountValue: number
}): {
  discountAmountInPence: number
  payableAmountInPence: number
} => {
  let discountAmountInPence
  if (discountType === VoucherType.percentage) {
    discountAmountInPence = parseFloat(
      ((discountValue / 100) * priceInPence).toFixed(0)
    )
  } else {
    discountAmountInPence =
      discountValue < priceInPence ? discountValue : priceInPence
  }
  return {
    discountAmountInPence,
    payableAmountInPence: priceInPence - discountAmountInPence,
  }
}
